var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title-inset"},[_c('div',{staticClass:"text d-inline-block pt-2 px-3 font-weight-bold",class:_vm.color,style:({'border-top-left-radius': '5px', 'border-top-right-radius': '5px'})},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }